import { OrderBook, OrderBook_OrderBookQuote } from '../proto/generated/security'
import { Snapshot } from '../reducer/security.reducer'

export const orderBookQuoteEquals = (a?: OrderBook_OrderBookQuote, b?: OrderBook_OrderBookQuote) =>
    a === b ||
    (a?.price === b?.price &&
        a?.quantity === b?.quantity &&
        a?.numberOfOrders === b?.numberOfOrders)

export const orderBookQuotesEqual = (a?: OrderBook_OrderBookQuote[], b?: OrderBook_OrderBookQuote[]) => {
    if (a === b) return true
    if (!a || !b || a.length !== b.length) return false
    for (let i = 0; i < a.length; i++) {
        if (!orderBookQuoteEquals(a[i], b[i])) return false
    }
    return true
}

export const orderBookDepthTickEquals = (a?: OrderBook, b?: OrderBook) =>
    a === b ||
    (orderBookQuotesEqual(a?.bids, b?.bids) &&
        orderBookQuotesEqual(a?.asks, b?.asks) &&
        a?.totalBuyQuantity === b?.totalBuyQuantity &&
        a?.totalSellQuantity === b?.totalSellQuantity)

export const orderBookOverviewTickEquals = (a?: OrderBook, b?: OrderBook) =>
    a === b ||
    (orderBookTickEquals(a, b) &&
        a?.volumeTradedToday === b?.volumeTradedToday &&
        a?.lastTradedTime === b?.lastTradedTime &&
        a?.lowerCircuit === b?.lowerCircuit &&
        a?.upperCircuit === b?.upperCircuit &&
        a?.lastTradedQuantity === b?.lastTradedQuantity &&
        a?.averageTradedPrice === b?.averageTradedPrice &&
        a?.session === b?.session &&
        a?.openInterest === b?.openInterest &&
        a?.inav === b?.inav &&
        a?.auction?.indicativePrice === b?.auction?.indicativePrice &&
        a?.auction?.indicativeQuantity === b?.auction?.indicativeQuantity &&
        a?.auction?.totalImbalanceQuantity === b?.auction?.totalImbalanceQuantity &&
        a?.auction?.marketImbalanceQuantity === b?.auction?.marketImbalanceQuantity &&
        a?.auction?.referencePrice === b?.auction?.referencePrice)

export const snapshotTickEquals = (a?: Snapshot, b?: Snapshot) =>
    a === b ||
    (a?.lastTradedPrice === b?.lastTradedPrice &&
        a?.previousClose === b?.previousClose &&
        a?.volume === b?.volume)

export const orderBookTickEquals = (a?: OrderBook, b?: OrderBook) =>
    a === b ||
    (a?.lastTradedPrice === b?.lastTradedPrice &&
        a?.open === b?.open &&
        a?.high === b?.high &&
        a?.low === b?.low &&
        a?.close === b?.close)

export const orderBookBidAskTickEquals = (a?: OrderBook, b?: OrderBook) =>
    a === b ||
    (orderBookTickEquals(a, b) &&
        a?.bids?.[0]?.price === b?.bids?.[0]?.price &&
        a?.asks?.[0]?.price === b?.asks?.[0]?.price)

export const snapshotsRecordTickEquals = (
    a: Record<string, Snapshot> | null,
    b: Record<string, Snapshot> | null
) => {
    if (a === b) return true
    if (!a || !b) return a === b
    const keys = new Set([...Object.keys(a), ...Object.keys(b)])
    for (const key of keys) {
        if (!snapshotTickEquals(a[key], b[key])) return false
    }
    return true
}

export const orderBooksRecordTickEquals = (
    a: Record<string, OrderBook> | null,
    b: Record<string, OrderBook> | null,
    equals: (x?: OrderBook, y?: OrderBook) => boolean = orderBookBidAskTickEquals
) => {
    if (a === b) return true
    if (!a || !b) return a === b
    const keys = new Set([...Object.keys(a), ...Object.keys(b)])
    for (const key of keys) {
        if (!equals(a[key], b[key])) return false
    }
    return true
}
